export const productCategories = {
  'mobile-topup': 'Recarga móvil',
  'data-plan': 'Paquetico',
  'pin': 'Pin',
  'invoice': 'Factura',
  'energy-topup': 'Recarga de electricidad',
  'betting-topup': 'Recarga de apuesta',
  'insurance': 'Seguro',
  'other': 'Otros servicios'
};

export const productCategoryList = Object
  .entries(productCategories)
  .map(([key, value]) => ({ key, value }));
